module.exports = __webpack_public_path__ + "media/images/4-01-0cdc8e22665b06f74a70c82aa394b53d.svg";